import { SxProps, Theme } from "@mui/material";
import { getStatusKey, StatusType } from "../../../../interfaces/entities/OutrasSolictacoesFinanceiras/MinhasSolicitacoes";

export const sxPaginationSolicitacoes: SxProps = {
  width: "auto",
  height: "32px",
  background: "unset",
  color: "unset",
  fontSize: "unset",
  fontStyle: "unset",
  fontWeight: "unset",
  lineHeight: "unset",
  position: "unset",
  button: {
    fontFamily: "UnimedSans-Bold",
    backgroundColor: "#EEE",
    color: "#5F5F5F",
    margin: "0 4px",
  },
};

export const sxLabelSolicitacoes: SxProps = {
  fontFamily: "Unimed-Sans",
  color: "#383838",
  fontWeight: 600,
};

export const sxValidationMessageSolicitacoes: SxProps = {
  fontFamily: "Unimed-Sans",
  color: "#D84141",
  fontSize: 12,
  marginTop: "4px",
};

export const sxDateInputSolicitacoes: SxProps = {
  width: "100%",
  "& .MuiInputBase-root": {
    borderRadius: "8px",
    height: "48px",
  },
  "& .MuiInputBase-input": {
    padding: "12px 16px",
    fontSize: "14px",
    fontFamily: "Unimed-Sans",
  },
};

interface StatusStyle {
  color: string;
}

export const sxStatusSolicitacoes: Record<string, StatusStyle> = {
  concluido: {
    color: "#00995D",
  },
  recusado: {
    color: "#D84141",
  },
  analise: {
    color: "#F5A300",
  },
};

export const sxStatusTextSolicitacoes = (
  status: StatusType,
  isContrastMode: boolean
): SxProps<Theme> => ({
  color: isContrastMode
    ? "#FFF"
    : sxStatusSolicitacoes[getStatusKey(status)]?.color || "#383838",
  fontFamily: "Unimed-Sans",
  fontWeight: 400,
});

export const sxButtonText: SxProps = {
    textDecoration: 'none',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 300,
    padding: 0,
    '&:hover': {
        textDecoration: 'none',
        color: 'inherit',
    }
}